import * as types from '../constants/ActionTypes'
import axios from "axios";
import category from '../components/category';

// Url's
// const getFilterItems = `${process.env.REACT_APP_API_URL}api/csa-app`;
const getFilterItems = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog`;
const getAllSearchResultsUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/product-search`;


// Filters
// All
export const filterAllSuccess = (allFilters) => ({
  type: types.SEARCH_FILTER_ALL_SUCCESS,
  allFilters
});
export const filterAllRequested = () => ({
  type: types.SEARCH_FILTER_ALL_REQUEST
});

export const filterAllFailure = error => ({
  type: types.SEARCH_FILTER_ALL_FAILURE,
  error
});

//search product

export const searchAllSuccess = (allFilters) => ({
  type: types.PRODUCT_SEARCH_FILTER_ALL_SUCCESS,
  allFilters
});
export const searchAllRequested = () => ({
  type: types.PRODUCT_SEARCH_FILTER_ALL_REQUEST
});

export const searchAllFailure = error => ({
  type: types.PRODUCT_SEARCH_FILTER_ALL_FAILURE,
  error
});


// Reset Filter
export const resetFilterSuccess = () => ({
  type: types.SEARCH_FILTER_RESET_SUCCESS
});

// seach filters selected

export const setFilters = (selected) => ({
  type: types.SEARCH_FILTER_SET,
  selected
});


// API
export const getAllSearchFilters = (connection_id, category_id) => {

  return dispatch => {
    dispatch(filterAllRequested());
    axios.get(getFilterItems + '/category-filter', {
      params: {
        connection_id,
        category_id
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(filterAllSuccess(res.data.results.category_filter_data));
        } else if (res.data.ack === "Failure") {
          dispatch(filterAllFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
//get Serach result in home page 
export const getAllSearchResults=(options)=>{
  return dispatch => {
   dispatch(searchAllRequested());
   axios.post(getAllSearchResultsUrl,options,{
     headers: {
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
       //'Content-Type': 'application/json; charset=UTF-8'
     },
   }) 
   
   .then(res => {
        if (res.data.ack === "Success") {
          
          dispatch(searchAllSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {

          dispatch(searchAllFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
 }
}

export const setSearchFilters = (selectedFilters) => {
  return dispatch => {
    dispatch(setFilters(selectedFilters));
  };
};

export const restFilters = () => {
  return dispatch => {
    dispatch(resetFilterSuccess());
  };
};